import React, {Component} from 'react';
import {graphql} from 'react-apollo';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import {NavLink} from 'react-router-dom';
import {reverse} from 'core/urls';
import {camelize} from 'core/utils';
import userQuery from 'graphql/queries/user.gql';
import styles from './styles.css';

@graphql(userQuery, {name: 'userData'})
@autobind
export default class OptionsSidebar extends Component {
    static propTypes = {
        links: PropTypes.array.isRequired,
        userType: PropTypes.string,
        refundType: PropTypes.string,
        action: PropTypes.string,
    };

    static defaultProps = {
        action: 'create',
    }

    getLinks() {
        const texts = {
            dealerCrops: {
                title: <p className={styles.name}>Pedido de Bolsas</p>,
                subtitle: <p>Solicitá tus bolsas para el Campo Líder</p>,
            },
            multiplierCrops: {
                title: <p className={styles.name}>Selección de Cultivo</p>,
                subtitle: <p>Informá el cultivo que vas a sembrar</p>,
            },
            dealerRefund: {
                title: <p className={styles.name}>Presupuesto de Jornada</p>,
                subtitle: <p>Para autorización de gastos</p>,
            },
            multiplierRefund: {
                title: <p className={styles.name}>Solicitud de Jornada</p>,
                subtitle: <p>Solicitá la fecha para la charla</p>,
            },
            kits: {
                title: <p className={styles.name}>Invitaciones y Kits</p>,
                subtitle: <p>Hacé el pedido de invitación y kits<br />para convocar y recibir a tus invitados</p>,
            },
            bags: {
                title: <p className={styles.name}>Pedido de Bolsas</p>,
                subtitle: <p>Solicitá tus bolsas para el lado a lado</p>,
            },
            clTrialSigns: {
                title: <p className={styles.name}>Pedido de Carteles</p>,
                subtitle: <p>Solicitá tus carteles de ensayo</p>,
            },
            llTrialSigns: {
                title: <p className={styles.name}>Pedido de Carteles</p>,
                subtitle: <p>Solicitá tus carteles de lado a lado</p>,
            },
        };

        return this.props.links
            .filter(link => {
                const orderCategory = camelize([this.props.refundType, this.props.userType, link]);
                return Boolean(this.props.userData.user.permissions[orderCategory]);
            })
            .map(link => {
                let text = texts[link];
                if (!text) text = texts[camelize([this.props.refundType, link])];
                if (!text) text = texts[camelize([this.props.userType, link])];
                return {
                    ...text,
                    url: reverse(camelize([this.props.refundType, this.props.userType, link, this.props.action])),
                };
            });
    }

    render() {
        if (this.props.userData.loading) return null;

        return (
            <div className={styles.root}>
                {this.getLinks().map(link => (
                    <NavLink
                        to={link.url}
                        key={link.url}
                        className={styles.option}
                        activeClassName={styles.active}>
                        {link.title}
                        {link.subtitle}
                    </NavLink>
                ))}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/options-sidebar/index.js